import React from "react";
import {Card} from "../../../../../components/card/card.jsx";
import Button from "../../../../../components/button/button.jsx";
import InputCheckbox from "../../../../../components/input/input-checkbox.jsx";
import InputForm from "../../../../../components/input/input-form.jsx";
import InputTextarea from "../../../../../components/input/input-textarea.jsx";
import SelectComponent from "../../../../../components/select/select-component.jsx";
import SentryRow from "../../../../../components/template/sentry-row.jsx";
import {MaskDefault} from "../../../../../utils/mask.js";

const REQUIRED_BG = "!bg-[#fdfdee]";
const REQUIRED_LABEl_BG = "!bg-[linear-gradient(to_bottom,transparent_50%,#fdfdee_50%)]";

const ScheduleAttendanceDataCard = ({
    id,
    form,
    reasonOptions,
    priorityOptions,
    channelOptions,
    hasProcedure,
    onChangeField,
    onLoadProcedure,
    onToggleInactive,
}) => (
    <Card>
        <Card.Header>
            <Card.Title>Dados</Card.Title>
        </Card.Header>
        <Card.Body className="flex flex-col gap-4">
            <SentryRow>
                <InputForm
                    classNameWrapper="col-span-6"
                    inputClass={REQUIRED_BG}
                    labelClass={REQUIRED_LABEl_BG}
                    id="name"
                    label="Nome *"
                    value={form.name}
                    onChange={({target}) => onChangeField("name", target.value)}
                />
                <InputForm
                    classNameWrapper="col-span-3"
                    id="userCreated"
                    label="Cadastrado"
                    value={id && form.userCreated ? `${form.userCreated} em ${form.systemCreationDate}` : ""}
                    disabled
                />
                <InputForm
                    classNameWrapper="col-span-3"
                    id="lastUser"
                    label="Última alteração"
                    value={id && form.userUpdated ? `${form.userUpdated} em ${form.systemUpdateDateView}` : ""}
                    disabled
                />
            </SentryRow>

            <SentryRow>
                <SelectComponent
                    classNameWrapper="col-span-7"
                    id="reason"
                    label="Natureza *"
                    options={reasonOptions}
                    value={form.reason}
                    onChange={(option) => onChangeField("reason", option)}
                />
                <Button className="col-span-1 h-[32px]" disabled={!hasProcedure} onClick={onLoadProcedure}>
                    Modelo
                </Button>
                <SelectComponent
                    classNameWrapper="col-span-4"
                    id="priority"
                    label="Prioridade"
                    options={priorityOptions}
                    value={form.priority}
                    onChange={(option) => onChangeField("priority", option)}
                />
            </SentryRow>

            <SentryRow>
                <SelectComponent
                    classNameWrapper="col-span-4"
                    id="channel"
                    label="Canal *"
                    options={channelOptions}
                    value={form.channel}
                    onChange={(option) => onChangeField("channel", option)}
                />
                <InputForm
                    classNameWrapper="col-span-4"
                    id="contactName"
                    label="Solicitante"
                    value={form.contactName}
                    onChange={({target}) => onChangeField("contactName", target.value)}
                />
                <InputForm
                    classNameWrapper="col-span-4"
                    id="contactPhone"
                    label="Telefone"
                    mask={MaskDefault.phone}
                    value={form.contactPhone}
                    onChange={({target}) => onChangeField("contactPhone", target.value)}
                />
            </SentryRow>

            <InputTextarea
                className=""
                textAreaClass={`${REQUIRED_BG} h-25!`}
                labelClass={REQUIRED_LABEl_BG}
                id="description"
                label="Descrição *"
                value={form.description}
                onChange={({target}) => onChangeField("description", target.value)}
            />

            <div className="flex flex-col gap-3">
                <InputCheckbox
                    id="inactive"
                    label="Inativar"
                    checked={form.inactive}
                    onChange={({target}) => onToggleInactive(target.checked)}
                />
                {form.inactive &&
                    <InputTextarea
                        className=""
                        textAreaClass={`${REQUIRED_BG} h-25!`}
                        labelClass={REQUIRED_LABEl_BG}
                        id="inactiveObservation"
                        label="Motivo da inativação *"
                        value={form.inactiveObservation}
                        onChange={({target}) => onChangeField("inactiveObservation", target.value)}
                    />
                }
            </div>
        </Card.Body>
    </Card>
);

export default ScheduleAttendanceDataCard;
